import { getTranslateByKey } from "@/main/services/utils";
import { formatCurrency } from "@/main/services/utilsNumber";

interface ITypographyPriceCapProps {
	priceCap: number | string;
}

function TypographyPriceCap({ priceCap }: ITypographyPriceCapProps) {
	const priceCapFormatted = typeof priceCap === "number" ? formatCurrency(priceCap) : priceCap;

	return (
		<p style={{ margin: "0" }} translate="no">
			{getTranslateByKey("information.priceCap")}: {priceCapFormatted}
		</p>
	);
}

export default TypographyPriceCap;
